import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  container: {
    width: '100%',
    height: '100%',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    overflow: 'scroll',
    [theme.breakpoints.up('mobile')]: {
      overflow: 'unset',
    },
  },
  content: {
    margin: [0, theme.spacing(4)],
    padding: [theme.spacing(4), 0, 0],
    position: 'relative',
    display: 'flex',
    flexFlow: 'column',
    flexDirection: 'column',
    [theme.breakpoints.up('mobile')]: {
      minWidth: 700,
      width: '100%',
      height: '100%',
      maxWidth: 1420,
      margin: [0, 'auto'],
      padding: [theme.spacing(7), 20, 0],
    },
  },
  header: {
    marginBottom: theme.spacing(5),
    [theme.breakpoints.up('mobile')]: {
      marginBottom: theme.spacing(8),
      fontSize: 32,
    },
  },
  addIcon: {
    color: theme.palette.colors.teal,
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    [theme.breakpoints.up('mobile')]: {
      flexDirection: 'row',
    },
  },
  form: {
    height: '100%',
    position: 'relative',
    [theme.breakpoints.up('mobile')]: {
      width: 500,
      height: 'unset',
    },
  },
  loanOfficersList: {
    [theme.breakpoints.up('mobile')]: {
      marginLeft: theme.spacing(4),
    },
  },
  button: {
    width: '100%',
    marginTop: theme.spacing(2),
    [theme.breakpoints.up('mobile')]: {
      width: 310,
      position: 'absolute',
      bottom: theme.spacing(5),
      left: 0,
    },
  },
}));



// WEBPACK FOOTER //
// ./src/components/RealEstateAgentDashboard/useStyles.js